import { useEffect, useState, useRef } from "react"
import Link from "next/link"
import axios from "axios"
import { convertSecondToTimePlay } from "utils/time"
import React from "react"
import Tippy from "@tippyjs/react"
import "tippy.js/dist/tippy.css"
import Image from "next/legacy/image"
import IconStar from "assets/icon/iconStar"

let calling = false

export default function BoxRelatedTo({
  query,
  shareVideo,
  setShareVideo,
  setShowPopup,
  isShow,
  setIsShow,
  watchLaterList,
  setIsSavedVideoRcm
}) {
  const [loading, setLoading] = useState(false)
  const [rows, setRows] = useState([])
  const [isMobile, setIsMobile] = useState(false)
  const [isTablet, setIsTablet] = useState(false)
  const divRef = useRef(null)
  const pageNum = useRef(0)
  const maxCount = useRef(50)
  const wapper = useRef()

  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth < 768)
      setIsTablet(window.innerWidth >= 768 && window.innerWidth < 1024)
    }

    handleResize()
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  const handleCheckExistVideo = (initVideo) => {
    const isExist = watchLaterList?.some((video) => video.id === initVideo.id)
    setIsSavedVideoRcm(isExist)
  }

  useEffect(() => {
    handleCheckExistVideo(shareVideo)
  }, [shareVideo])

  useEffect(() => {
    function handleClickOutside(event) {
      if (divRef.current && !divRef.current.contains(event.target)) {
        setIsShow(false)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [isShow])

  async function fetch(list) {
    try {
      pageNum.current = pageNum.current + 1
      const res = await axios.get("/api/related-to", {
        params: {
          ...query,
          page_num: pageNum.current,
          page_size: 10
        }
      })
      const { data, count } = res.data
      maxCount.current = count
      setRows([...list, ...data])
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
      calling = false
    }
  }

  useEffect(() => {
    function onScroll(e) {
      const { scrollHeight, scrollTop, offsetHeight } = e.target
      if (scrollTop + 350 > scrollHeight - offsetHeight) {
        if (!calling) {
          setLoading(true)
        }
      }
    }
    if (wapper.current) {
      wapper.current.addEventListener("scroll", onScroll)
      return () => {
        if (wapper.current) wapper.current.removeEventListener("scroll", onScroll)
      }
    }
  }, [])

  useEffect(() => {
    if (loading && maxCount.current > rows.length) fetch(rows)
  }, [loading])

  useEffect(() => {
    pageNum.current = 0
    fetch([])
  }, [query])

  return (
    <div className="rounded flex flex-col w-full gap-2">
      <div className="text-base leading-[22px] md:text-[22px] md:leading-[30px] font-semibold text-[#FAFAF9] pb-2 max-md:hidden">
        Video liên quan
      </div>
      {rows.length > 0 ? (
        <div
          className="overflow-y-auto relative overflow-x-hidden scroll__video flex max-md:flex max-md:flex-col max-lg:grid flex-col max-lg:grid-cols-3 max-lg:gap-3"
          ref={wapper}
        >
          {rows?.map((initVideo) => {
            const { type, name, id, league_name, league_id, thumbnail_horizontal, is_live, duration, is_premium } =
              initVideo
            const _link = `/video?id=${id}&type=${type}`
            return (
              <div className="rounded-xl max-lg:p-0 p-2 hover:bg-[#232323] max-md:bg-[#FFFFFF0A]" key={id}>
                <div className="flex max-lg:flex-col gap-4 max-lg:gap-2">
                  <Link href={_link}>
                    <div className="relative wapper__play">
                      <div className="fix_img shadow-sm" style={{ minWidth: 170 }}>
                        <Image
                          width={isMobile ? 716 : isTablet ? 458 : 170}
                          height={isMobile ? 404 : isTablet ? 258 : 95}
                          className="rounded-xl object-cover max-md:rounded-b-none"
                          src={thumbnail_horizontal || "/placeholder_video.svg"}
                        />
                        {is_premium && (
                          <div className="flex items-center gap-1 absolute top-3 left-0 bg-[linear-gradient(to_right,#FF4D00,#F67A36)] py-1 px-2">
                            <IconStar />
                            <span className="text-[#FFEB99] text-xs font-bold">Premium</span>
                          </div>
                        )}
                      </div>
                      {is_live && (
                        <div className="absolute bottom-2 right-1 bg-[#5F1515] rounded-lg flex items-center justify-center px-2 py-[3px] gap-1">
                          <img src="/icons/iconRedDot.svg" />
                          <div className="text-xs text-[#FCE8E6] font-medium">Trực tiếp</div>
                        </div>
                      )}
                      {!is_live && (
                        <div className="font-medium py-0.5 px-2 absolute text-sm bottom-2 right-1 bg-[#13131385] rounded-lg">
                          <div>{convertSecondToTimePlay(duration)}</div>
                        </div>
                      )}
                      <div className="layer__play rounded-xl">
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M7.30078 7.65618C7.30078 5.43726 9.6747 4.02636 11.6238 5.08689L27.6938 13.8309C29.7298 14.9387 29.7298 17.8616 27.6938 18.9695L11.6238 27.7135C9.6747 28.774 7.30078 27.3631 7.30078 25.1442V7.65618Z"
                            fill="#FAFAF9"
                          />
                        </svg>
                      </div>
                    </div>
                  </Link>
                  {!isMobile ? (
                    <div className="flex flex-col gap-3 items-start justify-center w-full py-1.5 max-lg:py-0 col-span-3">
                      <Link href={_link}>
                        <Tippy content={name}>
                          <div className="font-semibold max-md:font-normal text-base max-md:text-sm text-ellipsis text-[#fafaf9] line-clamp-2 max-md:px-4">
                            {name}
                          </div>
                        </Tippy>
                      </Link>
                      {league_name && !isTablet && (
                        <Link href={`/league?id=${league_id}`}>
                          <span className="text-[#FAFAF9] bg-[#0C3B80] rounded-[32px] py-1 px-2.5 w-fit text-sm font-normal line-clamp-1 hover:bg-primary hover:text-[#FAFAF9]">
                            {league_name}
                          </span>
                        </Link>
                      )}
                    </div>
                  ) : (
                    <div className="flex gap-2 justify-between items-center pb-4 px-4">
                      <div className="font-extrabold max-md:font-normal text-base max-md:text-sm text-ellipsis text-[#fafaf9] line-clamp-2">
                        {name}
                      </div>
                      <div
                        onClick={() => {
                          setShareVideo(initVideo)
                          setIsShow(true)
                          setShowPopup(false)
                          handleCheckExistVideo(initVideo)
                        }}
                      >
                        <img src="/icons/iconDetailVideo.svg" />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )
          })}
        </div>
      ) : (
        <div className="flex w-full h-full items-center justify-center">
          <p>Danh sách trống</p>
        </div>
      )}
    </div>
  )
}
